@import '@hevoio/hevo-ui-toolkit/styles/variables';

@import 'variables';

.queryEditor {
  min-height: $workbench-query-editor-default-height;
}

.unverifiedChangesWarning {
  color: $warning;
  border-radius: $border-radius-sm;
  background-color: $warning-faded-1;
}
